<template>
  <div ref="layout" class="page-form">
    <!-- <div class="tools" /> -->

    <h3 class="title">开票信息查看</h3>

    <div class="form-container">
      <div class="tools">
        <form-button @click="$router.go(-1)">返回</form-button>
      </div>
      <el-form inline size="mini" disabled label-width="140px" :model="conditions" :rules="rules">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="通知单号">
              <el-input
                v-model="conditions.invoInfoid"
                placeholder="自动生成"
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                v-model="conditions.uname"
                placeholder=""
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-input
                v-model="conditions.uzeit"
                placeholder=""
                type="text"
                disabled
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="开票客户编号">
              <el-input
                v-model="conditions.customer"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="开票客户名称">
              <el-input
                v-model="conditions.custName"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="开票日期">
              <el-input
                v-model="conditions.makDate"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="产品编号">
              <el-input
                v-model="conditions.orderedProd"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="产品名称">
              <el-input
                v-model="conditions.description"
                placeholder="请选择"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="计量单位">
              <el-input
                v-model="conditions.unit"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="发票号">
              <el-input
                v-model="conditions.invoId"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="手工发票号">
              <el-input
                v-model="conditions.invManual"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="发货类型">
              <el-input
                v-model="conditions.zzfld00002k"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="发票性质">
              <el-input
                v-model="conditions.invType"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="发票来源">
              <el-input
                v-model="conditions.invSource"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="删除方式">
              <el-input
                v-model="conditions.deleteMode"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="数量（件）">
              <el-input
                v-model="conditions.useZzfld9"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="已发货数量（件）">
              <el-input
                v-model="conditions.wantQuantity"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="删除标记">
              <el-input
                v-model="conditions.deleteFlag"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="订单客户编号">
              <el-input
                v-model="conditions.mcustomer"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="订单客户名称">
              <el-input
                v-model="conditions.mcustName"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="执行方式">
              <el-input
                v-model="conditions.executeModle"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="是否结清">
              <el-input
                v-model="conditions.ifSettled"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="计划年度">
              <el-input
                v-model="conditions.planYear"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="是否触发">
              <el-input
                v-model="conditions.ifTrigger"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="删除日志">
              <el-input
                v-model="conditions.deleteLog"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="是否仓库前移">
              <el-input
                v-model="conditions.isEntrepotMove"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="配额类型">
              <el-input
                v-model="conditions.notice_sheet_type"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="收货单位客户类型">
              <el-input
                v-model="conditions.harvestCustomerType"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="送达方">
              <el-input
                v-model="conditions.zzfld00008t"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="收货地址">
              <el-input
                v-model="conditions.zzfld00002n"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="联系人">
              <el-input
                v-model="conditions.zzfld00002l"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="联系电话">
              <el-input
                v-model="conditions.zzfld00002m"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="终端客户名称">
              <el-input
                v-model="conditions.zzfld00008x"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="终端客户编码">
              <el-input
                v-model="conditions.zzfld00008w"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="货权转移量">
              <el-input
                v-model="conditions.transferQty"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="业务子类型">
              <el-input
                v-model="conditions.zzfld00009c"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元">
              <el-select
                v-model="conditions.zzfld000001"
                @change="onChangeYxdy"
              >
                <el-option
                  v-for="item in saleList"
                  :key="item.SOBID"
                  :value="item.SOBID"
                  :label="item.MC_SHORT"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="配送方式">
              <el-input
                v-model="conditions.deliveryModel"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="经典五粮液品鉴">
              <el-input
                v-model="conditions.wlyTasting"
                placeholder=""
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon
        title="发货信息"
        :custome-config="() => vxeShowCustom('xTable')"
      >
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          max-height="500"
          align="center"
          size="small"
          :empty-render="{name: 'NotData'}"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <span>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>
  </div>
</template>

<script>
import { findByInvoInfoid } from '@/api/applyForGoods/index'
import { apiGetOrgOrBase } from '@/api/sap/common-sap'
export default {
  data() {
    return {
      loading: false,
      conditions: {
        deliverType: '',
        province: '',
        provinceCode: '',
        saleCenter: '',
        saleCenterView: '',
        customerName: '',
        customerCode: '',
        createdDate: '',
        createdByName: '',
        createdById: '',
        city: '',
        cityCode: '',
        billCode: '',
        area: '',
        status: '',
        transferQty: ''
      },
      routeQuery: {},
      selectDataOptions: {},
      saleList: [],
      gridOptions: {
        columns: [
          { field: 'createdDate', title: '发货日期' },
          { field: 'wantCode', title: '要货单号'},
          { field: 'productDesc', title: '产品名称' },
          { field: 'customerCode', title: '客户编码' },
          { field: 'customerName', title: '客户名称' },
          { field: 'occupyQty', title: '发货量' },
          { field: 'billStatus', title: '是否作废', formatter: ({ cellValue }) => cellValue === 'E005' ? '是' : '否' },
          { field: 'billStatusTextView', title: '审批状态' },
          { field: 'objectId', title: 'CRM订单号' }
          // { field: 'remark', title: '是否删除' }
        ],
        data: []
      }
    }
  },
  computed: {
    isEdit() {
      return true
    }
  },
  created() {
    apiGetOrgOrBase('', 1).then(res => {
      this.saleList = res.DATA
    })
    this.routeQuery = this.$route.query
    this.queryData()
  },
  methods: {
    async queryData() {
      this.loading = true
      try {
        const { data } = await findByInvoInfoid(this.routeQuery)
        Object.assign(this.conditions, data)
        this.gridOptions.data = data.sendOutDTOList
      } catch (e) {
        //
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/data-searching/invoiceInformationCheck.vue